import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@bvhi/ui-base";
import { useBlocker } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  isDirty: boolean;
}

export const FormBlockerDialog = ({ isDirty }: Props) => {
  const { t } = useTranslation(["dialogs"]);
  const { proceed, reset, status } = useBlocker({
    condition: isDirty,
  });

  /**
   * Will block refreshing or closing the tab with a dirty form state.
   * Will not block back navigation from browser.
   * Is currently not supported by @tanstack/router:
   * https://github.com/TanStack/router/issues/701
   */
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = true;
    };
    if (isDirty) {
      window.addEventListener("beforeunload", handleBeforeUnload);
    }
    return () => {
      if (isDirty) {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      }
    };
  }, [isDirty]);

  return (
    <>
      {status === "blocked" && (
        <Dialog disableEscapeKeyDown open={true}>
          <DialogTitle>{t("dialogs:dialogs.form.blocker.dialog.title")}</DialogTitle>
          <DialogContent>
            <DialogContentText>{t("dialogs:dialogs.form.blocker.dialog.text")}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={reset} variant="text">
              {t("dialogs:dialogs.form.blocker.dialog.cancel")}
            </Button>
            <Button onClick={proceed}>{t("dialogs:dialogs.form.blocker.dialog.proceed")}</Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};
